<!--Modal: Login / Register Form-->
<div mdbModal #formLogin="mdb-modal" class="modal fade" id="modalLRForm" tabindex="-1" role="dialog"
     aria-labelledby="formLogin"
     aria-hidden="true" (onShow)="cleanDataModel(); showLogin()"
     [config]="{ignoreBackdropClick: true}">

  <div class="modal-dialog cascading-modal" role="document">
    <!--Content-->
    <div class="modal-content">

      <!--Modal cascading tabs-->
      <div class="modal-c-tabs">

        <!-- Tab panels -->
        <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-2 modal-head darken-3'" [contentClass]="''"
                    class="tab-content">
          <!--Panel 7-->
          <mdb-tab class="tab-pane fade in show active" id="panel7" role="tabpanel"
                   heading="<i class='fa fa-user mr-1'></i> Iniciar sesión">

            <!--Body-->
            <div class="modal-body mb-1">
              <form [formGroup]="loginForm" (submit)="loginForm.valid && loginUser()">
                <div class="md-form form-sm">
                  <mdb-icon fas icon="envelope" class="prefix"></mdb-icon>
                  <input mdbInput #inputEmail type="email" id="email_login" class="form-control form-control-sm"
                         formControlName="defaultFormEmail" [(ngModel)]="login.email">
                  <label for="email_login" (click)="changeFocusEmail()">Correo electrónico</label>
                  <div *ngIf="loginForm.controls['defaultFormEmail'].dirty">
                    <div *ngIf="loginForm.controls['defaultFormEmail'].errors?.required"
                         class="text-danger animated fadeInDown fast-4 small">
                      El correo electrónico es obligatorio.
                    </div>
                    <div *ngIf="loginForm.controls['defaultFormEmail'].errors?.email"
                         class="text-danger animated fadeInDown fast-4 small">
                      Formato de correo incorrecto.
                    </div>
                  </div>
                </div>

                <div class="md-form form-sm">
                  <mdb-icon fas icon="lock" class="prefix"></mdb-icon>
                  <input mdbInput #inputPasssword type="password" id="password_login" class="form-control form-control-sm"
                         formControlName="defaultFormPass" [(ngModel)]="login.password">
                  <label for="password_login" (click)="changeFocusPassword()">Contraseña</label>
                  <div *ngIf="loginForm.controls['defaultFormPass'].dirty">
                    <div *ngIf="loginForm.controls['defaultFormPass'].errors?.required"
                         class="text-danger animated fadeInDown fast-4 small">
                      La contraseña es obligatoria.
                    </div>
                  </div>
                </div>
                <div class="text-center mt-2">
                  <button type="submit" class="btn btn-primary" mdbWavesEffect>
                    <mdb-icon fas icon="sign-in-alt" class="ml-1"></mdb-icon>
                    Iniciar sesión
                  </button>
                </div>
              </form>
            </div>

            <!--Footer-->
            <div class="modal-footer display-footer">
              <div class="options text-center text-md-left mt-1">
                <p class="mb-1">¿Olvidó <a href="javascript: void(0)" class="custom-color-text font-weight-bold"
                                           (click)="showRecover()">su contraseña?</a></p>
              </div>
              <button type="button" class="btn btn-danger ml-auto btn-md" data-dismiss="modal"
                      (click)="formLogin.hide()" mdbWavesEffect>Cerrar
              </button>
            </div>

          </mdb-tab>
          <!--/.Panel 7-->

          <!--Panel 9-->
          <mdb-tab class="tab-pane fade" id="panel9" role="tabpanel"
                   heading="<i class='fa fa-user mr-1'></i> Recuperar cuenta">

            <!--Body-->
            <div class="modal-body">
              <form [formGroup]="recoverForm" (submit)="recoverForm.valid && recoverAccount()">
                <div class="md-form form-sm">
                  <mdb-icon fas icon="envelope" class="prefix"></mdb-icon>
                  <input mdbInput #inputEmailRecover type="text" id="defaultFormEmailRecover" class="form-control form-control-sm"
                         formControlName="defaultFormEmailRecover" [(ngModel)]="recoverModel.correo">
                  <label for="defaultFormEmailRecover" (click)="changeFocusEmailRecover()">Correo electrónico de recuperación</label>
                  <div *ngIf="recoverForm.controls['defaultFormEmailRecover'].dirty">
                    <div *ngIf="recoverForm.controls['defaultFormEmailRecover'].errors?.required"
                         class="text-danger animated fadeInDown fast-4 small">
                      El correo electrónico es obligatorio.
                    </div>
                    <div *ngIf="recoverForm.controls['defaultFormEmailRecover'].errors?.email"
                         class="text-danger animated fadeInDown fast-4 small">
                      Formato de correo incorrecto.
                    </div>
                  </div>
                </div>
                <div class="text-center mt-2">
                  <button type="submit" class="btn btn-primary" mdbWavesEffect>
                    <mdb-icon fas icon="send" class="ml-1"></mdb-icon>
                    Solicitar recuperación
                  </button>
                </div>
              </form>
            </div>

            <!--Footer-->
            <div class="modal-footer display-footer">
              <div class="options text-center text-md-left mt-1">
                <p class="mb-1">
                  Ingrese su dirección de correo electrónico asociada a su cuenta.
                </p>
              </div>
              <button type="button" class="btn btn-danger btn-md" data-dismiss="modal"
                      (click)="formLogin.hide()" mdbWavesEffect>Cerrar
              </button>
            </div>
          </mdb-tab>
          <!--/.Panel 9-->

        </mdb-tabset>

      </div>
    </div>
    <!--/.Content-->
  </div>
</div>
<!--Modal: Login / Register Form-->
